<template>
    <div class="courses-table">

        <table>
            <tr v-for="(s, index) in schemes.filter(s => s.count)" :key="index">
                <td>{{ s.name }}</td><td class="count"> {{s.count}} </td>                
            </tr>

        </table>
    </div>
</template>

<script>
import * as d3_array from 'd3-array'

function get_medicine_course_count(med, med_units, medicines) {
    let candidate = medicines
        .filter(m => m.medicine === med)[0]

    if (!candidate) return null;

    let unitsTotal = d3_array.sum(candidate.rows, r => +r.unitBalanseEnd)
    return Math.floor(unitsTotal / med_units);
}

export default {
    props: ['f', 'config'],

    computed: {
        schemes() {
            return this.config.schemes.map(s => {
                let course = this.calculate_course(s, this.f.last_r.medicines);
                return {name: s.name, count: course}
            })
        }
    },

    methods: {
        calculate_course(scheme, medicines) {
            let med1_count = get_medicine_course_count(scheme.med1, scheme.med1_units, medicines);
            if (!med1_count) return null;

            if (!scheme.med2) return med1_count;

            let med2_count = get_medicine_course_count(scheme.med2, scheme.med2_units, medicines);
            if (!med2_count) return null;

            return Math.min(med1_count, med2_count);
        }
    }
}
</script>

<style lang="scss" scoped>
table {
    border-collapse: collapse;
    tr { 
        
    }

    td {
        font-size: 0.8rem;
        border: 1px solid black;
        color: var(--col-mainblue);
        padding: 0.5rem;
    }

    .count {text-align: right;}

    tr:first-child td {
        border-top: 0;
    }
    tr td:first-child {
        border-left: 0;
    }
    tr:last-child td {
        border-bottom: 0;
    }
    tr td:last-child {
        border-right: 0;
    }
}




</style>